import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Modal,
} from "react-bootstrap";
import { RotateCw, Upload } from "react-feather";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NotyfContext from "../../contexts/NotyfContext";
import {
  blankUploadDocument,
  uploadDocument,
} from "../../redux/slices/UploadDocumentSlice";
// import { FileUploader } from "react-drag-drop-files";
import Dropzone from "../../components/dropzone/Dropzone";
import Cropper from "react-easy-crop";
import getCroppedImg from "../../components/cropImage";
import {
  fetchNotification,
  setNotifcationBedge,
} from "../../redux/slices/CommonSlice";
import documentIcon from "./add-document-icon.svg";
import RotateIcon from '../../assets/img/rotate-solid.svg';

const AddDocument = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const uploadDocumentFile = useSelector(
    (state) => state.uploadDocument.uploadDocument
  );
  const notyf = useContext(NotyfContext);
  const [fileUpload, setFileUpload] = useState(null);
  const [fileType, setFileType] = useState("");
  const [previewImage, setPreviewImage] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [srcImg, setSrcImg] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const SUPPORTED_FORMATS = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"];
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);
  const handleChange = (file) => {
    // if (e.target.files && e.target.files.length > 0) {
    //     const fileExtension = e.target.files[0].name.split(".").at(-1);
    //     if(SUPPORTED_FORMATS.includes(fileExtension)){
    //         setFileUpload(e.target.files[0])
    //     }else{
    //         notyf.open({
    //             type:"danger",
    //             message: "Only png,jpg and jpeg allowed",
    //             duration:"3000",
    //             ripple:false,
    //             dismissible:false,
    //             position: {
    //               x: "right",
    //               y: "top"
    //             },
    //         });
    //     }
    // }
    setFileUpload(file);
  };
  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        srcImg,
        croppedAreaPixels,
        rotation
      );
      fetch(croppedImage).then(async (response) => {
        const contentType = response.headers.get("content-type");
        const blob = await response.blob();
        let filename = new Date().valueOf();
        const file = new File([blob], `${filename}.jpg`, { contentType });
        // setLogo(file);
        setPreviewImage(URL.createObjectURL(file));
        setFileUpload(file);
      });
      setShowImageModal(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels]);
  const onDrop = useCallback((file) => {
    const fileData = file[0];
    const fileExtension = fileData.name.split(".").at(-1);
    if (SUPPORTED_FORMATS.includes(fileExtension)) {
      // setPreviewImage(URL.createObjectURL(file[0]));
      // setFileUpload(file[0])
      const reader = new FileReader();
      reader.addEventListener("load", () => setSrcImg(reader.result));
      reader.readAsDataURL(file[0]);
      setShowImageModal(true);
    } else {
      notyf.open({
        type: "danger",
        message: "Only png,jpg and jpeg allowed",
        duration: "3000",
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
    }
  });
  useEffect(() => {
    if (uploadDocumentFile && Object.keys(uploadDocumentFile).length > 0) {
      if (uploadDocumentFile.error == 0) {
        notyf.open({
          type: "success",
          message: "Document uploaded successfully",
          duration: "3000",
          ripple: false,
          dismissible: false,
          position: {
            x: "right",
            y: "top",
          },
        });
        dispatch(blankUploadDocument());
        setFileUpload(null);
        setFileType("");
        setTimeout(() => {
          navigate("/documents");
        }, 3000);
      } else {
        notyf.open({
          type: "danger",
          message: uploadDocumentFile.msg,
          duration: "3000",
          ripple: false,
          dismissible: false,
          position: {
            x: "right",
            y: "top",
          },
        });
      }
    }
  }, [uploadDocumentFile]);

  const handleSubmit = () => {
    let message = "";
    if (fileType === "") {
      message = "Please select ID";
    }
    if (!fileUpload) {
      message = "Please upload the file";
    }
    if (message !== "") {
      notyf.open({
        type: "danger",
        message: message,
        duration: "3000",
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
    } else {
      //drivers_license
      //social_security
      //proof_of_address
      if (fileType === "ID") {
        let obj = {
          drivers_license: fileUpload,
        };
        dispatch(uploadDocument(obj));
        dispatch(fetchNotification());
        dispatch(setNotifcationBedge(true));
      }
      if (fileType === "social_security") {
        let obj = {
          social_security: fileUpload,
        };
        dispatch(uploadDocument(obj));
        dispatch(fetchNotification());
        dispatch(setNotifcationBedge(true));
      }
      if (fileType === "proof_of_address") {
        let obj = {
          proof_of_address: fileUpload,
        };
        dispatch(uploadDocument(obj));
        dispatch(fetchNotification());
        dispatch(setNotifcationBedge(true));
      }
    }
  };
  const handleRotation = () => {
    let rotationOri = rotation;
    rotationOri += 90;
    if (rotation < 360) {
      setRotation(rotationOri);
    } else {
      setRotation(0);
    }
  };
  return (
    <React.Fragment>
      <Helmet title="Add Document" />
      <Container fluid className="p-0">
        <Row className="d-flex justify-content-center">
          <Col md="4">
            <Card className="border-0 shadow p-4 rounded">
              <Card.Body>
                <div className="d-flex gap-2 align-items-center mb-5">
                  <div
                    className="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
                    style={{ height: 40, width: 40 }}
                  >
                    <img src={documentIcon} />
                  </div>
                  <h3 className="p-0 m-0">Add Documents</h3>
                </div>

                <Form>
                  <Form.Group className="mb-5">
                    <Form.Label>Title</Form.Label>
                    <Form.Select
                      name="document_type"
                      id="document_type"
                      size="lg"
                      onChange={(e) => setFileType(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="ID">ID</option>
                      <option value="social_security">Social Security</option>
                      <option value="proof_of_address">Proof of Social Security</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-5">
                    <Form.Label>Attach Document</Form.Label>
                    {/* <Form.Control 
                                            type="file"
                                            name="attach_document"
                                            id="attach_document"
                                            size="lg"
                                            onChange={(e)=>handleChange(e)}
                                        /> */}
                    {/* <FileUploader 
                                            handleChange={handleChange}
                                            types={SUPPORTED_FORMATS}
                                            name="attach_document"
                                            id="attach_document"
                                            label="Drag and Drop here or Browse file Accepted File Type jpg,jpeg and png"
                                            classes="drop_area drop_zone"
                                        /> */}
                    <Card className="mb-0" style={{ cursor: "pointer" }}>
                      <Dropzone
                        onDrop={onDrop}
                        image={previewImage}
                        accept={"image/*"}
                      />
                    </Card>
                  </Form.Group>

                  <Button
                    variant="primary"
                    className="w-100"
                    size="lg"
                    onClick={() => handleSubmit()}
                  >
                    Upload a file <Upload size={20} />
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>Crop Image</Modal.Header>
        <Modal.Body>
          {srcImg ? (
            <>
              <div style={{ height: "400px", width: "70%" }}>
                <Cropper
                  image={srcImg}
                  crop={crop}
                  rotation={rotation}
                  zoom={zoom}
                  // maxZoom={1}
                  // zoomWithScroll={true}
                  // showGrid={true}
                  aspect={16 / 9}
                  onRotationChange={setRotation}
                  onCropChange={setCrop}
                  onCropComplete={onCropComplete}
                  onZoomChange={setZoom}
                  // cropSize = {{width:600,height:400}}
                  // objectFit="horizontal-cover"
                />
              </div>
            </>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
        <div className='controls'>
            <style>{`
            .controls {

	bottom: 11px !important;

}
            `}</style>
            <input
              type='range'
              value={zoom}
              min={1}
              max={3}
              step={0.1}
              aria-labelledby='Zoom'
              onChange={e => {
                setZoom(e.target.value);
              }}
              className='zoom-range'
            />
            <br />
            <Button variant='primary' className='w-50 ms-3 d-flex align-items-center gap-3 justify-content-center' onClick={() => handleRotation()}>
             <img src={RotateIcon} alt="RotateIcon" width="25"  /> Rotate
            </Button>
          </div>
          <Button variant="secondary" onClick={() => setShowImageModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={() => showCroppedImage()}>
            Crop
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default AddDocument;
